var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	93649: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	67629: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	6078: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	82512: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	69930: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	50064: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	48394: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	24951: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	69347: {
		fallback: () => (__webpack_require__.e("node_modules_auth0_auth0-spa-js_dist_auth0-spa-js_production_esm_js").then(() => (() => (__webpack_require__(/*! @auth0/auth0-spa-js */ 86377))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.21.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-spa-js",

	},
	65428: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	44525: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	69066: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	95341: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_auth0_auth0-spa-js_auth0_auth0-spa-js"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_auth0_auth0-angular_fesm2022_auth0-auth0-angular_mjs")]).then(() => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/auth0-angular",

	},
	68983: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @snelstart/util-state-store */ 27964))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@snelstart/util-state-store",

	},
	66832: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @auth0/angular-jwt */ 92389))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@auth0/angular-jwt",

	},
	96465: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_graphql-tag_lib_index_js")]).then(() => (() => (__webpack_require__(/*! graphql-tag */ 89067))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.12.7",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql-tag",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		93649
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		67629
	],
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		6078
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		82512,
		69930
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		50064
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		48394
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		24951
	],
	"default-webpack_sharing_consume_default_auth0_auth0-spa-js_auth0_auth0-spa-js": [
		69347
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		65428
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		44525
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		69066
	],
	"default-webpack_sharing_consume_default_auth0_auth0-angular_auth0_auth0-angular": [
		95341
	],
	"default-webpack_sharing_consume_default_snelstart_util-state-store_snelstart_util-state-store": [
		68983
	],
	"default-webpack_sharing_consume_default_auth0_angular-jwt_auth0_angular-jwt": [
		66832
	],
	"node_modules_apollo-angular_fesm2022_apollo-angular_mjs": [
		96465
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}